import { IScheduleActionTypes, IScheduleState } from "models/IScheduleState";

const initialState: IScheduleState = {
  schedule_overall_info: {
    schedule_tab: 0,
    schedule_config_id: 0,
    schedule_start_date: "",
    schedule_end_date: "",
    shift: {},
  },
  weeks_range_info: {},
};

const reducer = (state = initialState, { type, payload }: any) => {
  switch (type) {
    case IScheduleActionTypes.UPDATE_SCHEDULE_SELECTED_TAB:
      return {
        ...state,
        schedule_overall_info: {
          ...state.schedule_overall_info,
          ...payload.data,
        },
      };

    case IScheduleActionTypes.FETCH_SCHEDULE_SLOTS_DETAILS_REQUEST:
      return {
        ...state,
        slots: [],
      };
    case IScheduleActionTypes.FETCH_SCHEDULE_SLOTS_DETAILS_SUCCESS:
      return {
        ...state,
        slots: [...(payload.data || [])],
      };
    case IScheduleActionTypes.FETCH_SCHEDULE_LOCATION_DETAILS_REQUEST:
      return {
        ...state,
        location: [],
      };
    case IScheduleActionTypes.FETCH_SCHEDULE_LOCATION_DETAILS_SUCCESS:
      return {
        ...state,
        locations: [...payload.data],
      };
    case IScheduleActionTypes.FETCH_SCHEDULE_PROJECTS_DETAILS_REQUEST:
      return {
        ...state,
        projects: [],
      };
    case IScheduleActionTypes.FETCH_SCHEDULE_PROJECTS_DETAILS_SUCCESS:
      return {
        ...state,
        projects: [...payload.data],
      };

    case IScheduleActionTypes.FETCH_SCHEDULE_SUB_PROJECTS_DETAILS_REQUEST:
      return {
        ...state,
        subProjects: [],
      };
    case IScheduleActionTypes.FETCH_SCHEDULE_SUB_PROJECTS_DETAILS_SUCCESS:
      return {
        ...state,
        subProjects: [...payload.data],
      };

    case IScheduleActionTypes.FETCH_ALL_EMP_SCHEDULE_DETAILS_REQUEST:
      return {
        ...state,
        empDetails: {},
      };
    case IScheduleActionTypes.FETCH_ALL_EMP_SCHEDULE_DETAILS_SUCCESS:
      return {
        ...state,
        empDetails: { ...payload.data },
      };
    case IScheduleActionTypes.UPDATE_TOTAL_SCHEDULE_COUNT:
      return {
        ...state,
        totalCounts: payload.data,
      };
    case IScheduleActionTypes.RESET_TOTAL_SCHEDULE_COUNT:
      return {
        ...state,
        totalCounts: 0,
      };
    case IScheduleActionTypes.FETCH_ALL_EMP_LEAVES_INFO_REQUEST:
      return {
        ...state,
        leavesInfo: {},
      };
    case IScheduleActionTypes.FETCH_ALL_EMP_LEAVES_INFO_SUCCESS:
      return {
        ...state,
        leavesInfo: { ...payload.data },
      };
    case IScheduleActionTypes.UPDATE_EMP_SCHE_DETAILS_REQUEST:
      return {
        ...state,
        isUpdateSuccess: false,
      };
    case IScheduleActionTypes.UPDATE_EMP_SCHE_DETAILS_SUCCESS:
      return {
        ...state,
        isUpdateSuccess: payload.data,
      };
    case IScheduleActionTypes.DOWNLOAD_EMP_SCHE_DETAILS_REQUEST:
      return {
        ...state,
        empScheduleDetails: [],
      };
    case IScheduleActionTypes.DOWNLOAD_EMP_SCHE_DETAILS_SUCCESS:
      return {
        ...state,
        empScheduleDetails: [...payload.data],
      };
    case IScheduleActionTypes.FETCH_SCHEDULE_WORK_TYPE_DETAILS_REQUEST:
      return {
        ...state,
        workTypes: [],
      };
    case IScheduleActionTypes.FETCH_SCHEDULE_WORK_TYPE_DETAILS_SUCCESS:
      return {
        ...state,
        workTypes: [...payload.data],
      };
    case IScheduleActionTypes.FETCH_SCHEDULE_LEADS_DETAILS_SUCCESS:
      return {
        ...state,
        leads: [...payload.data],
      };
    case IScheduleActionTypes.FETCH_EMPLOYEES_FILTERED_SUCCESS:
      return {
        ...state,
        ...payload.data,
      };
    case IScheduleActionTypes.FECTH_UNSCHEDULED_EMPLOYEES_LIST_REQUEST:
      return {
        ...state,
        unscheduled_list: [],
      };
    case IScheduleActionTypes.FETCH_UNSCHEDULED_EMPLOYEES_LIST_SUCCESS:
      return {
        ...state,
        unscheduled_list: [...payload.data],
      };
    case IScheduleActionTypes.FETCH_SCHEDULE_LEADS_DETAILS_REQUEST:
      return {
        ...state,
        leads: [],
      };

    case IScheduleActionTypes.FETCH_SCHEDULE_LEADS_DETAILS_REQUEST:
      return {
        ...state,
        requested_resources_info: {},
      };

    case IScheduleActionTypes.FETCH_REQUESTED_RESOURCES_LIST_SUCCESS:
      return {
        ...state,
        requested_resources_info: payload.data,
      };

    case IScheduleActionTypes.FETCH_EVENT_REQUEST_LIST_REQUEST:
      return {
        ...state,
        event_request_info: {},
      };

    case IScheduleActionTypes.FETCH_EVENT_REQUEST_LIST_SUCCESS:
      return {
        ...state,
        event_request_info: payload.data,
      };

    case IScheduleActionTypes.FETCH_WEEKS_RANGE_LIST_REQUEST:
      return {
        ...state,
        weeks_range_info: {},
      };

    case IScheduleActionTypes.FETCH_WEEKS_RANGE_LIST_SUCCESS:
      return {
        ...state,
        weeks_range_info: { ...payload },
      };

    default:
      return state;
  }
};

export default reducer;
